const VERSION = '3.2.1';
export function getVersionString() {
    return VERSION;
}
